import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type TrophyProps = Omit<BusinessIconImageProps, 'color' | 'secondaryColor' | 'strokeWidth'>;

const Trophy = ({ size = 24, width, height, alt = '', style, ...props }: TrophyProps) =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(-2.21848 -0.655347) scale(1.57983)',
        },
        [
          h(
            'g',
            {
              mask: 'url(#mask0_trophy)',
            },
            [
              h(
                'path',
                {
                  d: 'M3.1948 5.37708C3.67681 4.84521 4.53923 4.9633 5.13708 5.24502C5.48273 5.41471 5.90915 5.28949 6.09121 4.96443C6.27359 4.63843 6.14078 4.2349 5.79477 4.06308L5.79371 4.06255C4.61466 3.48068 3.03081 3.5028 2.11742 4.51052C1.3322 5.37677 1.42962 6.72855 2.10042 7.75746C2.80768 8.84199 4.18326 9.6773 6.16665 9.6773C6.55801 9.6773 6.87497 9.37864 6.87497 9.01011C6.87497 8.64161 6.55801 8.34289 6.16665 8.34289C4.63947 8.34289 3.73843 7.72008 3.30742 7.05905C2.84026 6.3423 2.93731 5.66093 3.1948 5.37708ZM14.8052 5.37708C14.3232 4.84521 13.4608 4.9633 12.8629 5.24502C12.5173 5.41471 12.0908 5.28949 11.9088 4.96443C11.7264 4.63843 11.8592 4.2349 12.2052 4.06308L12.2063 4.06255C13.3853 3.48068 14.9692 3.5028 15.8826 4.51052C16.6678 5.37677 16.5704 6.72855 15.8996 7.75746C15.1923 8.84199 13.8167 9.6773 11.8334 9.6773C11.442 9.6773 11.125 9.37864 11.125 9.01011C11.125 8.64161 11.442 8.34289 11.8334 8.34289C13.3605 8.34289 14.2616 7.72008 14.6926 7.05905C15.1597 6.3423 15.0627 5.66093 14.8052 5.37708ZM9.90598 10.0106H8.09402L7.64601 12.2077C7.58863 12.4887 7.3432 12.7047 7.03577 12.745L5.77458 12.9106C5.31804 12.9706 4.95254 13.2887 4.86223 13.7043L4.7588 14.179C4.70285 14.4367 4.91711 14.6774 5.20329 14.6774H12.7967C13.0829 14.6774 13.2971 14.4367 13.2412 14.179L13.1378 13.7043C13.0475 13.2887 12.682 12.9707 12.2254 12.9107L10.9642 12.745C10.6568 12.7047 10.4114 12.4887 10.354 12.2077L9.90598 10.0106Z',
                  fill: '#FF934A',
                },
              ),
              h(
                'path',
                {
                  d: 'M5.05173 8.89875C5.3471 10.5028 6.8619 11.6772 8.63594 11.6772H9.36408C11.1381 11.6772 12.6529 10.5028 12.9483 8.89875L13.5929 5.39834C13.6813 4.91888 13.8403 4.45337 14.0654 4.01528L14.4964 3.17528C14.9026 2.38325 14.5707 1.62434 13.6227 1.52341C12.7057 1.42578 11.2621 1.34375 9.00001 1.34375C6.73792 1.34375 5.29434 1.42578 4.37737 1.52344C3.42926 1.62437 3.09739 2.38325 3.50363 3.17531L3.93468 4.01528C4.15978 4.45337 4.31881 4.91888 4.40716 5.39834L5.05173 8.89872V8.89875Z',
                  fill: '#FCBF28',
                },
              ),
            ],
          ),
          h(
            'defs',
            {
            },
            [
              h(
                'mask',
                {
                  id: 'mask0_trophy',
                  maskUnits: 'userSpaceOnUse',
                  x: '1',
                  y: '1',
                  width: '16',
                  height: '14',
                },
                [
                  h(
                    'rect',
                    {
                      x: '1',
                      y: '1',
                      width: '16',
                      height: '14',
                      fill: 'white',
                    },
                  ),
                  h(
                    'path',
                    {
                      d: 'M8.59835 3.57466C8.76729 3.26678 9.23266 3.26678 9.4016 3.57466L9.94845 4.57213L11.1137 4.78919C11.4583 4.85334 11.5975 5.24828 11.3626 5.49531L10.5346 6.36666L10.6862 7.52922C10.7305 7.86809 10.3582 8.11709 10.0352 7.96463L8.99997 7.47578L7.96473 7.96463C7.64173 8.11709 7.26949 7.86806 7.31379 7.52922L7.46536 6.36666L6.63731 5.49531C6.40249 5.24828 6.54168 4.85334 6.8863 4.78919L8.05149 4.57213L8.59835 3.57469V3.57466Z',
                      fill: 'black',
                    },
                  ),
                ],
              ),
            ],
          ),
        ],
      ),
    ],
  );

export default Trophy;
